import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Settings } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

interface SlideMenuProps {
  title: string;
}

export const SlideMenu: React.FC<SlideMenuProps> = ({ title }) => {
  const { t } = useLanguage();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="w-full flex items-center justify-start gap-3 px-2 md:px-3 py-1.5 md:py-2 text-foreground hover:text-primary text-sm md:text-base">
          <Settings className="w-4 h-4 md:w-5 md:h-5 text-foreground" />
          <span className="text-foreground">{t(title)}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56 bg-popover border shadow-lg z-50">
        <DropdownMenuItem className="hover:bg-accent">
          {t("settings")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
